module.exports = __webpack_public_path__ + "8c3cdb7a514e2d2ee8edebd9f945d4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/arrow_blue.png
// module id = 700
// module chunks = 0